import React, { InputHTMLAttributes } from 'react';

interface CheckboxPropsBase {
  onValue: (value: boolean) => void;
  label?: string;
  labelRender?: () => React.ReactNode;
}

type CheckboxProps = CheckboxPropsBase & InputHTMLAttributes<HTMLInputElement>;

export function Checkbox(props: CheckboxProps) {
  const { className: propClasses, onValue, label, labelRender, ...rest } = props;

  const classes = [];
  if (propClasses) classes.push(propClasses);
  classes.push('go-checkbox');

  const input = (
    <input
      type="checkbox"
      className={classes.join(' ')}
      onChange={e => onValue(e.target.checked)}
      {...rest}
    />
  );

  if (!label && !labelRender) return input;

  return (
    <label className="inline-flex items-center gap-2 cursor-pointer">
      {input}
      {labelRender ? labelRender() : <span>{label}</span>}
    </label>
  );
}

export default Checkbox;
